import React from 'react';
import { Select } from '../Select';
import { Field } from 'formik';
import { VirtualizedSelect } from '../VirtualizedSelect';

interface Props {
  label: string,
  name: string,
  fetchdata(): Promise<Datum[]>
}

export interface Datum {
  id?: string | number,
  value: any
}

interface State {
  data: Datum[]
}

export class RemoteSelect extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      data: []
    }
  }
  async componentDidMount() {
    try {
      const data = await this.props.fetchdata();
      this.setState({ data });
    } catch {
      console.log("Fetch Error");
    }
  }

  render() {
    const { label, name } = this.props;
    const { data } = this.state;
    return (
      <Field component={VirtualizedSelect} name={name} children={data} label={label} />
    )
  }
}